import { useRouteError } from 'react-router-dom'
import { userFacingMessage } from '../api/errors'
import { Button } from '../ui/Button'
import { ErrorState } from '../ui/Feedback'

/**
 * Route-level containment: a failure in one region does not blank the shell
 * (docs/16 section 9.2). Logged, never swallowed.
 */
export function RouteError() {
  const error = useRouteError()
  console.error('Route error', error)
  return (
    <ErrorState
      title="This screen could not be displayed"
      body={userFacingMessage(error)}
      action={<Button onClick={() => window.location.reload()}>Reload</Button>}
    />
  )
}
